import {
  PendingBatchStatus,
  PendingItemStatus,
  PendingStoreStatus,
} from "@/services/price-remark/types";

export const BADGE_BASE =
  "inline-block whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-semibold";

export interface BadgeStyle {
  label: string;
  className: string;
  dot: string;
}

export const ITEM_SITUATIONS: Record<PendingItemStatus, BadgeStyle> = {
  NAO_INICIADO: {
    label: "Não iniciado",
    className: "bg-red-50 text-red-600",
    dot: "#DC2626",
  },
  PARCIAL: {
    label: "Parcial",
    className: "bg-amber-50 text-amber-700",
    dot: "#D97706",
  },
  FALHA_IMPRESSAO: {
    label: "Falha impressão",
    className: "bg-red-100 text-red-900",
    dot: "#7F1D1D",
  },
  JUSTIFICADO: {
    label: "Justificado",
    className: "bg-gray-100 text-gray-700",
    dot: "#9CA3AF",
  },
  SEM_ESTOQUE: {
    label: "Sem estoque",
    className: "bg-gray-100 text-gray-400",
    dot: "#D1D5DB",
  },
  CONCLUIDO: {
    label: "Concluído",
    className: "bg-green-50 text-green-600",
    dot: "#16A34A",
  },
};

export const BATCH_STATUSES: Record<PendingBatchStatus, BadgeStyle> = {
  NAO_INICIADO: ITEM_SITUATIONS.NAO_INICIADO,
  EM_ANDAMENTO: {
    label: "Em andamento",
    className: "bg-amber-50 text-amber-700",
    dot: "#D97706",
  },
  CONCLUIDO: {
    label: "Concluído",
    className: "bg-green-50 text-green-600",
    dot: "#16A34A",
  },
};

export const STORE_STATUSES: Record<PendingStoreStatus, BadgeStyle> = {
  SILENCIOSA: {
    label: "Silenciosa",
    className: "bg-red-900 text-white",
    dot: "#7F1D1D",
  },
  PARADA: {
    label: "Parada",
    className: "bg-red-50 text-red-600",
    dot: "#DC2626",
  },
  LOTE_PARADO: {
    label: "Lote parado",
    className: "bg-amber-50 text-amber-700",
    dot: "#D97706",
  },
  ATIVA: {
    label: "Ativa",
    className: "bg-green-50 text-green-600",
    dot: "#16A34A",
  },
};
